import { render, staticRenderFns } from "./AdminContractPage.vue?vue&type=template&id=836a568c&scoped=true"
import script from "./AdminContractPage.vue?vue&type=script&lang=js"
export * from "./AdminContractPage.vue?vue&type=script&lang=js"
import style0 from "./AdminContractPage.vue?vue&type=style&index=0&id=836a568c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "836a568c",
  null
  
)

export default component.exports